import { c as _c } from "react/compiler-runtime";
import { isVODStatusFailed } from '@/hooks/useTrailerViewMedia';
import { getStreamUris } from '@/lib/blendvision';
import { createPlaybackToken } from '@/server/services/blendvision';
import { getVod } from '@/services/blendvision';
import type { TrailerViewVideoData } from '@/types/asset';
import useSWR from 'swr';
const POLLING_INTERVAL_MS = 10000;
const hasPendingVod = (videos: TrailerViewVideoData[] | undefined) => videos?.some(video => video.vodId && (!video.isConverted || !video.playbackToken) && !isVODStatusFailed(video.vodStatus)) ?? false;
const fetchVodStatus = async (videos: TrailerViewVideoData[]) => {
  return Promise.all(videos.map(async video => {
    if (!video.vodId || video.isConverted && video.playbackToken || isVODStatusFailed(video.vodStatus)) {
      return video;
    }
    const vodRes = await getVod(video.vodId);
    const vod = vodRes && 'vod' in vodRes ? vodRes.vod : undefined;
    if (!vod || isVODStatusFailed(vod.status)) {
      return {
        ...video,
        isConverted: false,
        vodStatus: vod?.status || 'UNKNOWN'
      };
    }
    if (vod.status !== 'VOD_STATUS_SUCCEEDED') return video;
    const playbackToken = await createPlaybackToken({
      resourceId: video.vodId,
      resourceType: 'RESOURCE_TYPE_VOD_EVENT'
    });
    if (!playbackToken) return video;
    const {
      token
    } = playbackToken;
    const coverImage = vod?.cover_image?.auto?.url;
    const {
      dashUri,
      hlsUri
    } = getStreamUris(vod.stream);
    return {
      ...video,
      isConverted: true,
      vodStatus: vod.status,
      ...(coverImage ? {
        coverImage
      } : {}),
      ...(token ? {
        playbackToken: token
      } : {}),
      title: vod.name,
      ...(dashUri && {
        dashUri
      }),
      ...(hlsUri && {
        hlsUri
      })
    };
  }));
};
const usePollTrailerViewBlendVisionVodStatus = videos => {
  const $ = _c(13);
  let t0;
  if ($[0] !== videos) {
    t0 = hasPendingVod(videos);
    $[0] = videos;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const shouldPoll = t0;
  let t1;
  if ($[2] !== videos) {
    t1 = videos.map(_temp);
    $[2] = videos;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const vodIds = t1;
  let t2;
  if ($[4] !== shouldPoll || $[5] !== vodIds) {
    t2 = shouldPoll ? ["vod-status-polling", vodIds] : null;
    $[4] = shouldPoll;
    $[5] = vodIds;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  let t4;
  if ($[7] !== videos) {
    t3 = () => fetchVodStatus(videos);
    t4 = latestVideos => hasPendingVod(latestVideos ?? videos) ? POLLING_INTERVAL_MS : 0;
    $[7] = videos;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== videos) {
    t5 = {
      refreshInterval: t4,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      fallbackData: videos
    };
    $[10] = t4;
    $[11] = videos;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    data: polledVideos
  } = useSWR(t2, t3, t5);
  return polledVideos;
};
export default usePollTrailerViewBlendVisionVodStatus;
function _temp(video) {
  return video.vodId;
}